import { SortKey } from '../../../../utils/tableHelper';

export const returnsReportColumns = {
  returnedDate: {
    label: 'Returned date',
    canBeSorted: true,
    sortKey: SortKey.RETURNED_AT,
    isDefault: true,
    isDate: true,
  },
  orderCreatedDate: {
    label: 'Order created date',
    canBeSorted: true,
    sortKey: SortKey.ORDER_CREATED_AT,
    isDefault: true,
    isDate: true,
  },
  salesChannel: {
    label: 'Sales channel',
    isDefault: true,
  },
  country: {
    label: 'Country',
  },
  returnCode: {
    label: 'Return code',
    canBeHidden: true,
  },
  returnReason: {
    label: 'Return reason',
    canBeHidden: true,
  },
  retailerOrderId: {
    label: 'Retailer order id',
    canBeHidden: true,
    isDefault: true,
  },
  salesOrderNumber: {
    label: 'Sales order id',
    canBeHidden: true,
  },
  sku: {
    label: 'SKU',
    canBeHidden: true,
    isDefault: true,
  },
  upc: {
    label: 'UPC',
    canBeHidden: true,
  },
  ean: {
    label: 'EAN',
    canBeHidden: true,
    isDefault: true,
  },
  model: { label: 'Model', canBeHidden: true, isDefault: true, canBeSorted: true, sortKey: SortKey.MODEL },
  productName: {
    label: 'Product name',
    canBeHidden: true,
    isDefault: true,
    canBeSorted: true,
  },
  unitsCount: {
    label: 'Ordered units',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  returnedUnits: {
    label: 'Returned units',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  refunded: {
    label: 'Is refund',
    canBeHidden: true,
    isDefault: true,
  },
  pricePerItem: {
    label: 'Price per item',
    canBeHidden: true,
    isDefault: true,
    isCurrency: true,
  },
  totalRefund: {
    label: 'Total refund',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
    isCurrency: true,
  },
  currency: { label: 'Currency', hidden: true },
  orderType: {
    label: 'Order type',
    canBeHidden: true,
  },
};
